import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, requiredRole }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRole) {
    // Only admins can access admin routes
    // Temporarily allowing members for testing - change back to user.role !== 'admin' after testing
    if (requiredRole === 'admin' && user.role !== 'admin' && user.role !== 'member') {
      return <Navigate to="/" />;
    }
    // Both members and admins can access member routes
    if (requiredRole === 'member' && user.role !== 'member' && user.role !== 'admin') {
      return <Navigate to="/" />;
    }
  }

  return children;
};

export default PrivateRoute;

